<template>
  <section class="content" v-loading="isloading">
    <div class="tabs">
      <!-- <router-link :to="{path:'/show/devinfo',query:{id:$route.query.id,show:true}}"> -->
      <div
        class="tab"
        :class="{ cur: iscur == 0 }"
        @click="toggleTab('devinfo', 0)"
      >
        <i class="fa fa-info-circle icon"></i
        ><span class="title">设备信息</span>
      </div>
      <!-- </router-link>
    <router-link :to="{path:'/show/current',query:{id:$route.query.id,show:true}}"> -->
      <div
        class="tab"
        :class="{ cur: iscur == 1 }"
        @click="toggleTab('current', 1)"
        v-if="isShowCurrent"
      >
        <i class="fa fa-sliders icon"></i><span class="title">实时数据</span>
      </div>
      <!-- </router-link>
    <router-link :to="{path:'/show/runview',query:{id:$route.query.id,show:true}}"> -->
      <div
        class="tab"
        :class="{ cur: iscur == 2 }"
        @click="toggleTab('runview', 2)"
        v-if="isShowView"
      >
        <i class="fa fa-image icon"></i><span class="title">组态流程</span>
      </div>
      <!-- </router-link>
    <router-link to="/show/histdata"> -->
      <div
        class="tab"
        :class="{ cur: iscur == 3 }"
        @click="toggleTab('histdata', 3)"
      >
        <i class="fa fa-line-chart icon"></i><span class="title">历史数据</span>
      </div>
      <!-- </router-link>
    <router-link to="/show/alarm"> -->
      <div
        class="tab"
        :class="{ cur: iscur == 4 }"
        @click="toggleTab('alarm', 4)"
      >
        <i class="fa fa-warning icon"></i><span class="title">报警记录</span>
      </div>
      <!-- </router-link>  v-if="isShowVideo"-->
      <div class="tab" :class="{cur:iscur==5}" @click="toggleTab('player',5)">
        <i class="fa fa-video-camera icon"></i>
        <span class="title">现场视频</span>
      </div>
      <!-- <router-link to="/show/dataopr"> -->
      <!-- <div
        class="tab"
        :class="{ cur: iscur == 6 }"
        @click="toggleTab('dataopr', 6)"
        v-if="isShowOpr"
      >
        <i class="fa fa-pencil-square-o icon"></i
        ><span class="title">写入数据</span>
      </div> -->
      <!-- </router-link> -->
      <!-- <div class="tab" :class="{cur:iscur==7}" @click="toggleTab('infoshare',7)"><i class="fa fa-qrcode icon"></i><span class="title">设备分享</span></div> -->
      <!-- <router-view :key="$router.fullPath"></router-view> -->
      <keep-alive>
        <component
          :is="currentTab"
          v-bind:Guid="id"
          v-bind:dev="devdetail"
          v-bind:showPage="true"
        ></component>
      </keep-alive>
    </div>
  </section>
</template>

<script>
export default {
  name: "Show",
  data() {
    return {
      id: "",
      iscur: -1,
      currentTab: "", // currentTab 用于标识当前触发的子组件
      isShowCurrent: false,
      isShowOpr: false,
      isShowView: false,
      isShowVideo: false,
      isloading: false,
      devdetail: {}
    };
  },
  methods: {
    toggleTab: function(tab, index) {
      this.currentTab = tab; // tab 为当前触发标签页的组件名
      this.iscur = index;
    },
    getShowTab() {
      let self = this;
      this.isloading = true;
      this.$api.post("Device/DetailV", { id: this.id }).then(res => {
        if (res.status === 200) {
          self.devdetail = res.data.Data;
          if (self.devdetail.view_url||self.devdetail.type_view_url) {
            self.isShowView = true;
          } else {
            self.isShowView = false;
          }
          if (self.devdetail.video_url) {
            self.isShowVideo = true;
          } else {
            self.isShowVideo = false;
          }
        }
      });
      this.$api.post("VarConf", { guid: this.id, isStore: "1" }).then(res => {
        if (res.status === 200) {
          //self.isShowCurrent = true;
        }
      });

      this.$api.post("VarConf", { guid: this.id, isShow: "1" }).then(res => {
        if (res.status === 200) {
          this.isShowCurrent = true;
        }
      });

      this.$api.post("VarConf", { guid: this.id, isModify: "1" }).then(res => {
        if (res.status === 200) {
          this.isShowOpr = true;

          this.currentTab = "devinfo";
          this.isloading = false;
        }
      });
    }
  },
  mounted() {},
  created() {
    this.id = this.$route.query.id;
    this.iscur = 0;

    this.getShowTab();
  },
  watch: {
    // 修复增改设备之后，重新加载页面，无法执行 created  函数
    $route(to, from) {
      if(to.fullPath.indexOf('/show/devinfo?id')===-1)
      {
        return;
      }
      this.id = this.$route.query.id;
      this.iscur = 0;
      this.getShowTab();
    }
  }
};
</script>
